import { render, staticRenderFns } from "./leadTasksView.vue?vue&type=template&id=6cb3b190&"
import script from "./leadTasksView.vue?vue&type=script&lang=js&"
export * from "./leadTasksView.vue?vue&type=script&lang=js&"
import style0 from "./leadTasksView.vue?vue&type=style&index=0&id=6cb3b190&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports